import { api } from '@/services/api/axios'
import type { GeneratedDocument, ReadinessResult } from '@/types'
import type {
  ListGeneratedDocumentsParams,
  ListGeneratedDocumentsResponse,
  GenerateDocumentData,
  UpdateDocumentStatusData,
  DownloadUrlResponse,
} from './documentGeneration.static'

export const documentGenerationService = {
  async listGeneratedDocuments(
    params: ListGeneratedDocumentsParams
  ): Promise<ListGeneratedDocumentsResponse> {
    const { patientId, ...query } = params
    const url = patientId ? `/patients/${patientId}/documents/generated` : `/documents/generated`
    const response = await api.get<{ data: ListGeneratedDocumentsResponse }>(url, { params: query })
    return response.data.data
  },

  async generateDocument(
    patientId: string,
    data: GenerateDocumentData
  ): Promise<GeneratedDocument> {
    const response = await api.post<{ data: GeneratedDocument }>(
      `/patients/${patientId}/documents/generate`,
      data
    )
    return response.data.data
  },

  async generateBundle(patientId: string): Promise<GeneratedDocument[]> {
    const response = await api.post<{ data: GeneratedDocument[] }>(
      `/patients/${patientId}/documents/generate-bundle`
    )
    return response.data.data
  },

  async checkReadiness(patientId: string): Promise<ReadinessResult> {
    const response = await api.get<{ data: ReadinessResult }>(
      `/patients/${patientId}/documents/readiness`
    )
    return response.data.data
  },

  async getDownloadUrl(documentId: string): Promise<DownloadUrlResponse> {
    const response = await api.get<{ data: DownloadUrlResponse }>(
      `/documents/generated/${documentId}/download`
    )
    return response.data.data
  },

  async updateStatus(
    documentId: string,
    data: UpdateDocumentStatusData
  ): Promise<GeneratedDocument> {
    const response = await api.patch<{ data: GeneratedDocument }>(
      `/documents/generated/${documentId}/status`,
      data
    )
    return response.data.data
  },

  async regenerate(documentId: string): Promise<GeneratedDocument> {
    const response = await api.post<{ data: GeneratedDocument }>(
      `/documents/generated/${documentId}/regenerate`
    )
    return response.data.data
  },

  async deleteGeneratedDocument(documentId: string): Promise<void> {
    await api.delete(`/documents/generated/${documentId}`)
  },
}
